// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import type { ReactNode } from 'react'
import React, { useContext, useMemo } from 'react'

import type { User } from 'lib-common/api-types/employee-auth'
import type { Action } from 'lib-common/generated/action'

import { UserContext } from '../state/user'

export const hasGlobalAction = (
  user: User | undefined,
  action: Action.Global
): boolean => user?.permittedGlobalActions.includes(action) ?? false

export const RequirePermittedGlobalAction = React.memo(
  function RequirePermittedGlobalAction({
    oneOf,
    children
  }: {
    oneOf: Action.Global[]
    children: ReactNode
  }) {
    const { user } = useContext(UserContext)
    const isPermitted = useMemo(
      () =>
        user?.permittedGlobalActions.some((a) => oneOf.includes(a)) || false,
      [oneOf, user]
    )

    return isPermitted ? <>{children}</> : null
  }
)
